/* Modulo: Video Reels — infinite coverflow + inline video player. Vanilla, no deps. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(root) {
    if (!root || root.__vrInit) return;
    var track = root.querySelector('[data-vr-track]');
    if (!track) return;
    var reels = Array.prototype.slice.call(root.querySelectorAll('[data-vr-reel]'));
    var n = reels.length;
    if (!n) return;
    root.__vrInit = true;

    var live = root.querySelector('[data-vr-live]');
    var prevBtn = root.querySelector('[data-vr-prev]');
    var nextBtn = root.querySelector('[data-vr-next]');
    var baseSpv = parseInt(root.getAttribute('data-vr-spv') || '5', 10) || 5;
    var autoplay = root.getAttribute('data-vr-autoplay') === '1';
    var active = Math.floor(n / 2);
    var prevOff = [];
    var i;
    for (i = 0; i < n; i++) prevOff[i] = null;

    function params() {
      var w = window.innerWidth, spv = baseSpv, gap = 0.66, lift = 8, scale = 0.085;
      if (w <= 480) { spv = Math.min(spv, 3); gap = 0.58; lift = 6; scale = 0.10; }
      else if (w <= 760) { spv = Math.min(spv, 5); gap = 0.62; lift = 7; scale = 0.092; }
      var side = Math.min(Math.floor(spv / 2), Math.floor((n - 1) / 2));
      return { side: side, gap: gap, lift: lift, scale: scale, loop: n > (2 * side + 1) };
    }

    function circOff(idx, loop) {
      var o = idx - active;
      if (loop) { o = ((o % n) + n) % n; if (o > n / 2) o -= n; }
      return o;
    }
    /* cumulative scaled spacing — outer cards tuck in, no orphan gap */
    function cumX(o, cw, p) {
      var a = Math.abs(o), s = 0, k;
      for (k = 1; k <= a; k++) s += cw * p.gap * Math.max(0.5, 1 - (k - 0.5) * p.scale);
      return (o < 0 ? -1 : 1) * s;
    }

    function layout(animate) {
      var p = params();
      var cw = reels[0].offsetWidth || 220;  /* offsetWidth ignores the scale transform */
      for (var j = 0; j < n; j++) {
        var el = reels[j];
        var o = circOff(j, p.loop), a = Math.abs(o);
        var wrapped = animate && p.loop && prevOff[j] !== null && Math.abs(o - prevOff[j]) > p.side + 1;
        if (wrapped) el.style.transition = 'none';
        el.classList.toggle('is-active', o === 0);
        if (o === 0) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
        var x = cumX(o, cw, p), y = a * p.lift, sc = Math.max(0.45, 1 - a * p.scale);
        var op = a <= p.side ? 1 : Math.max(0, 1 - (a - p.side) * 0.5);
        el.style.transform = 'translate(-50%,-50%) translateX(' + x.toFixed(1) + 'px) translateY(' + y + 'px) scale(' + sc.toFixed(3) + ')';
        el.style.opacity = String(op);
        el.style.zIndex = String(100 - Math.round(a));
        var vis = op > 0.05;
        el.style.pointerEvents = vis ? 'auto' : 'none';
        el.setAttribute('aria-hidden', vis ? 'false' : 'true');
        el.tabIndex = vis ? 0 : -1;
        if (wrapped) { void el.offsetWidth; el.style.transition = ''; }
        prevOff[j] = o;
      }
      if (prevBtn) prevBtn.disabled = !p.loop && active <= 0;
      if (nextBtn) nextBtn.disabled = !p.loop && active >= n - 1;
    }

    function announce() { if (live) live.textContent = reels[active].getAttribute('data-vr-label') || ''; }

    function pauseAll() {
      for (var j = 0; j < n; j++) {
        var v = reels[j].querySelector('video');
        if (v && !v.paused) v.pause();
        reels[j].classList.remove('is-playing');
        updateAria(reels[j]);
      }
    }
    function maybeAutoplayActive() {
      if (!autoplay || REDUCE) return;
      var el = reels[active], v = el.querySelector('video');
      if (!v) return;
      v.muted = true; el.classList.remove('is-unmuted');
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      el.classList.add('is-playing'); updateAria(el);
    }
    function swapEmbed(emb) {
      if (emb.__done) return; emb.__done = true;
      var f = document.createElement('iframe');
      f.src = emb.getAttribute('data-vr-embed');
      f.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
      f.setAttribute('allowfullscreen', 'true');
      f.setAttribute('title', 'Video');
      emb.appendChild(f);
    }
    function playWithSound(el) {
      pauseAll();
      var v = el.querySelector('video');
      if (v) {
        v.muted = false; el.classList.add('is-unmuted');
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        el.classList.add('is-playing'); updateAria(el);
      } else {
        var emb = el.querySelector('[data-vr-embed]'); if (emb) swapEmbed(emb);
      }
    }
    function togglePlay(el) {
      var v = el.querySelector('video');
      if (v) {
        if (v.paused) playWithSound(el);
        else { v.pause(); el.classList.remove('is-playing'); updateAria(el); }
      } else {
        var emb = el.querySelector('[data-vr-embed]'); if (emb) swapEmbed(emb);
      }
    }
    function toggleMute(el) {
      var v = el.querySelector('video'); if (!v) return;
      v.muted = !v.muted; el.classList.toggle('is-unmuted', !v.muted); updateAria(el);
    }
    function updateAria(el) {
      var pb = el.querySelector('[data-vr-play]');
      if (pb) { var playing = el.classList.contains('is-playing'); pb.setAttribute('aria-label', playing ? 'Pause' : 'Play'); pb.setAttribute('aria-pressed', playing ? 'true' : 'false'); }
      var mb = el.querySelector('[data-vr-mute]');
      if (mb) { var unmuted = el.classList.contains('is-unmuted'); mb.setAttribute('aria-label', unmuted ? 'Mute' : 'Unmute'); mb.setAttribute('aria-pressed', unmuted ? 'true' : 'false'); }
    }

    function onChange() { pauseAll(); layout(true); announce(); maybeAutoplayActive(); }
    function go(d) {
      var p = params();
      if (p.loop) active = ((active + d) % n + n) % n;
      else active = Math.min(n - 1, Math.max(0, active + d));
      onChange();
    }
    function setActive(idx) { active = idx; onChange(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(-1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { go(1); e.preventDefault(); }
    });

    reels.forEach(function (el, idx) {
      el.addEventListener('click', function () {
        if (idx !== active) { setActive(idx); return; }
        togglePlay(el);
      });
      var pb = el.querySelector('[data-vr-play]');
      if (pb) pb.addEventListener('click', function (e) { e.stopPropagation(); if (idx !== active) setActive(idx); togglePlay(el); });
      var mb = el.querySelector('[data-vr-mute]');
      if (mb) mb.addEventListener('click', function (e) { e.stopPropagation(); toggleMute(el); });
    });

    /* swipe */
    var sx = 0, sy = 0, drag = false;
    track.addEventListener('pointerdown', function (e) { drag = true; sx = e.clientX; sy = e.clientY; });
    window.addEventListener('pointerup', function (e) {
      if (!drag) return; drag = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    });
    track.addEventListener('pointercancel', function () { drag = false; });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        for (var k = 0; k < ents.length; k++) {
          if (ents[k].isIntersecting) maybeAutoplayActive();
          else pauseAll();
        }
      }, { threshold: 0.35 });
      io.observe(root);
    }

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { layout(false); }, 120); });

    layout(false);
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-vr]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();
